<template>
  <div class="overlay-modal">
    <div class="modal-card">

      <h5 class="titulo-empirulado">{{ esAlta ? 'Alta de Servicio' : 'Modificar Servicio' }}</h5>

      <Form
        role="form"
        class="card-empirulada q-pad q-mar-top fade-in"
        @submit="handleSubmit"
      >

        <!-- NOMBRE -->
        <div class="form-row-q">
          <div class="form-col-q">
            <soft-field
              type="text"
              id="nombre"
              v-model="form.nombre"
              :useLabel="true"
              label="Nombre del servicio"
              name="nombre"
              largo="80"
              class="label-q"
            />
          </div>
        </div>

        <!-- DESCRIPCION – EDITOR TRIX -->
        <div class="form-row-q">
          <div class="form-col-q">
            <div class="descripcion-wrapper">
              <label class="label-q">Descripción</label>
              <input id="descripcion" type="hidden" v-model="form.descripcion">
              <div class="trix-wrap">
                <trix-toolbar id="descripcion-toolbar"></trix-toolbar>
                <trix-editor
                  input="descripcion"
                  toolbar="descripcion-toolbar"
                  class="descripcion-trix"
                  @trix-change="form.descripcion = $event.target.value"
                ></trix-editor>
              </div>
            </div>
          </div>
        </div>

        <!-- PÚBLICO OBJETIVO -->
        <div class="form-row-q">
          <div class="form-col-q">
            <div class="q-field">
              <label class="label-q">Público objetivo</label>
              <div class="publico-objetivo-grid">
                <button
                  type="button"
                  class="flag-option flag-option-auto"
                  :class="{ active: form.publico_objetivo === '' }"
                  @click="form.publico_objetivo = ''"
                >
                  <span class="flag-emoji">🌍</span>
                  <span class="flag-text">Auto</span>
                </button>
                <button
                  type="button"
                  class="flag-option"
                  :class="{ active: form.publico_objetivo === 'es' }"
                  @click="form.publico_objetivo = 'es'"
                >
                  <span class="fi fi-es fis flag-icon"></span>
                  <span class="flag-text">Español</span>
                </button>
                <button
                  type="button"
                  class="flag-option"
                  :class="{ active: form.publico_objetivo === 'en' }"
                  @click="form.publico_objetivo = 'en'"
                >
                  <span class="fi fi-gb fis flag-icon"></span>
                  <span class="flag-text">Inglés</span>
                </button>
                <button
                  type="button"
                  class="flag-option"
                  :class="{ active: form.publico_objetivo === 'fr' }"
                  @click="form.publico_objetivo = 'fr'"
                >
                  <span class="fi fi-fr fis flag-icon"></span>
                  <span class="flag-text">Francés</span>
                </button>
                <button
                  type="button"
                  class="flag-option"
                  :class="{ active: form.publico_objetivo === 'pt' }"
                  @click="form.publico_objetivo = 'pt'"
                >
                  <span class="fi fi-pt fis flag-icon"></span>
                  <span class="flag-text">Portugués</span>
                </button>
              </div>
              <p class="help-q mt-2">
                Si no eliges uno concreto, se usará detección automática.
              </p>
            </div>
          </div>
        </div>

        <!-- TIPSTER (solo admin) -->
        <div class="form-row-q">
          <div class="form-col-q">
            <soft-select
              v-if="miRol == 1"
              id="tipsterid"
              v-model="form.tipsterid"
              name="tipsterid"
              :valores="tipsters"
              :useLabel="true"
              label="Tipster"
              class="label-select2 q-mar-bottom"
            />
          </div>
        </div>

        <!-- ENLACE -->
        <div class="form-row-q">
          <div class="form-col-q">
            <soft-field
              type="url"
              id="enlace"
              v-model="form.enlace"
              :useLabel="true"
              label="Enlace"
              name="enlace"
              class="label-input2 q-mar-bottom"
              largo="200"
            />
            <!-- Mensajes de verificación de canal (solo alta) -->
            <template v-if="esAlta">
              <p v-if="estadoVerificacionEnlace === 'checking'" class="help-q">
                Verificando canal en Telegram…
              </p>
              <p
                v-if="estadoVerificacionEnlace === 'ok' && botEnCanal"
                class="help-q help-ok"
              >
                Canal verificado. El bot está correctamente conectado ✅
              </p>
              <p
                v-if="estadoVerificacionEnlace === 'ok' && !botEnCanal"
                class="help-q help-warning"
              >
                {{ mensajeVerificacionEnlace }}
              </p>
              <p
                v-if="estadoVerificacionEnlace === 'error'"
                class="help-q help-error"
              >
                {{ mensajeVerificacionEnlace }}
              </p>
            </template>
          </div>
        </div>

        <!-- PRECIO + MONEDA -->
        <div class="form-row-q">
          <div class="form-col-q">
            <div class="precio-moneda-row q-mar-bottom">
              <!-- Precio -->
              <div class="precio-col">
                <soft-field
                  type="number"
                  id="precio"
                  v-model="form.precio"
                  :useLabel="true"
                  :label="'Precio (' + simboloMoneda + ')'"
                  name="precio"
                  class="label-q"
                />
                <!-- Preview precio (solo alta con precio dinámico activo) -->
                <div
                  v-if="esAlta && precioValido && form.usar_precio_dinamico && tienePrecioDinamicoConfig && precioFinalPreview < Number(form.precio)"
                  class="precio-preview mt-2"
                >
                  <span class="precio-normal">
                    {{ Number(form.precio || 0).toFixed(2) }} {{ simboloMoneda }}
                  </span>
                  <span class="precio-final">
                    {{ Number(precioFinalPreview || 0).toFixed(2) }} {{ simboloMoneda }}
                  </span>
                </div>
              </div>
              <!-- Moneda -->
              <div class="moneda-col">
                <label class="label-q">Moneda</label>
                <select
                  v-model="form.moneda"
                  class="select-moneda"
                  :disabled="esEdita && productoTieneSuscriptores"
                >
                  <option v-for="m in monedasDisponibles" :key="m.code" :value="m.code">
                    {{ m.code }} — {{ m.nombre }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Aviso moneda no-EUR -->
            <div v-if="form.moneda !== 'EUR'" class="aviso-moneda">
              <span class="aviso-moneda-icono">⚠️</span>
              <span class="aviso-moneda-texto">
                El cliente paga en <strong>{{ form.moneda }}</strong>.
                Stripe liquida el importe en <strong>EUR</strong> a tu cuenta bancaria
                usando el tipo de cambio del momento del cobro.
                El importe que recibes puede variar con el mercado de divisas.
              </span>
            </div>

            <!-- Aviso moneda bloqueada -->
            <div v-if="esEdita && productoTieneSuscriptores" class="aviso-tipo-venta-bloqueado mt-1">
              <span class="aviso-icono">🔒</span>
              <span class="aviso-texto">
                No se puede cambiar la moneda ya que tiene suscripciones activas.
              </span>
            </div>
          </div>
        </div>

        <!-- TIPO DE VENTA -->
        <div class="q-mar-top">
          <label class="label-q-bold">Tipo de venta</label>

          <!-- Aviso bloqueado: hay suscriptores -->
          <div v-if="esEdita && productoTieneSuscriptores" class="aviso-tipo-venta-bloqueado mt-2">
            <span class="aviso-icono">🔒</span>
            <span class="aviso-texto">
              No se puede cambiar el tipo de venta ya que tiene suscripciones activas.
            </span>
          </div>

          <div class="d-flex gap-3 mt-1">
            <label class="tipo-venta-opcion" :class="{ active: form.tipo_venta === 'venta_unica', 'tipo-venta-bloqueada': esEdita && productoTieneSuscriptores }">
              <input type="radio" :checked="form.tipo_venta === 'venta_unica'" :disabled="esEdita && productoTieneSuscriptores" @change="form.tipo_venta = 'venta_unica'" />
              <span>💳 Pago único</span>
            </label>
            <label class="tipo-venta-opcion" :class="{ active: esSuscripcion, 'tipo-venta-bloqueada': esEdita && productoTieneSuscriptores }">
              <input type="radio" :checked="esSuscripcion" :disabled="esEdita && productoTieneSuscriptores" @change="!esSuscripcion && (form.tipo_venta = 'mensual')" />
              <span>🔄 Suscripción</span>
            </label>
          </div>

          <!-- Sub-selector intervalo -->
          <div v-if="esSuscripcion" class="intervalo-grid mt-2">
            <button
              v-for="op in intervalosRecurrentes"
              :key="op.value"
              type="button"
              class="btn-intervalo"
              :class="{ active: form.tipo_venta === op.value }"
              :disabled="esEdita && productoTieneSuscriptores"
              @click="!(esEdita && productoTieneSuscriptores) && (form.tipo_venta = op.value)"
            >
              {{ op.label }}
            </button>
          </div>

          <p v-if="esSuscripcion && !(esEdita && productoTieneSuscriptores)" class="help-q mt-1" style="color:#1e88e5;">
            El cliente pagará automáticamente {{ labelIntervalo }}. El cobro se gestiona vía Stripe.
          </p>

          <!-- DÍAS DE GRACIA (trial) -->
          <div v-if="esSuscripcion" class="q-mar-top gracia-block">
            <label class="form-label-q">
              Periodo de prueba gratuito
              <span class="badge-gracia">opcional</span>
            </label>
            <div class="gracia-input-row">
              <input
                type="number"
                class="form-control-q gracia-input"
                v-model.number="form.dias_gracia"
                min="0"
                placeholder="0"
              />
              <span class="gracia-unidad">días</span>
            </div>
            <p class="help-q mt-1">
              Los nuevos suscriptores tendrán acceso gratuito durante este tiempo antes del primer cobro.
              <template v-if="esEdita && (productoTieneSuscriptores || true)">
                <br><span style="color:var(--q-gold);">Los suscriptores actuales no se ven afectados.</span>
              </template>
            </p>
          </div>
        </div>

        <!-- PRECIO DINÁMICO – ALTA -->
        <div v-if="esAlta" class="q-mar-top">
          <div class="switch-row-q">
            <QToggle
              id="usar_precio_dinamico"
              v-model="form.usar_precio_dinamico"
              :disabled="!precioValido"
              @change="togglePrecioDinamico"
            />
            <span class="switch-label-q">Usar Precio Dinámico</span>
          </div>
          <p v-if="!precioValido" class="help-q help-warning">
            Primero ingresa un precio mayor a 0 para activar el precio dinámico.
          </p>
          <p v-if="form.usar_precio_dinamico" class="help-q">
            Si se activa, el precio se calcula usando rebaja por % o precio rebajado + límite de usos.
          </p>
        </div>

        <!-- PRECIO DINÁMICO – EDITA -->
        <div v-if="esEdita" class="q-mar-top precio-dinamico-edita">
          <label class="label-q-bold">Precio dinámico (rebaja general)</label>
          <div class="d-flex align-items-center justify-content-between" style="gap:10px;">
            <div class="d-flex align-items-center" style="gap:10px;">
              <QToggle
                id="rebaja_activa"
                v-model="form.precio_dinamico.activo"
                @change="togglePrecioDinamicoEdita"
              />
              <span style="font-size:.9rem;">
                {{ form.precio_dinamico.activo ? 'Activado' : 'Desactivado' }}
              </span>
            </div>
            <QBtn variant="neutro" label="Configurar" @click.prevent="modalPrecioDinamicoVisible = true" />
          </div>
          <!-- Resumen rápido edita -->
          <div class="mt-3" style="font-size:.9rem;">
            <template v-if="form.precio_dinamico.activo">
              <span class="text-muted">Normal:</span>
              <b>{{ Number(form.precio || 0).toFixed(2) }}€</b>
              ·
              <span class="text-muted">Vista previa:</span>
              <b>{{ precioFinalPreview }}€</b>
              ·
              <span class="text-muted">Límite:</span>
              <b>{{ (form.precio_dinamico.limite_usos === '' || form.precio_dinamico.limite_usos === null) ? '∞' : form.precio_dinamico.limite_usos }}</b>
              ·
              <span class="text-muted">Usados:</span>
              <b>{{ productoEditRebajaUsados }}</b>
            </template>
            <template v-else>
              <span class="text-muted">Sin rebaja (mostrando precio normal).</span>
            </template>
          </div>
        </div>

        <!-- FECHA LÍMITE -->
        <div class="form-row-q bloque-fecha-limite">
          <div class="form-switch-q switch-row-q">
            <QToggle id="usa_fecha_limite" v-model="form.usa_fecha_limite" />
            <label for="usa_fecha_limite" class="switch-label-q">Hora de finalización del servicio</label>
          </div>
          <div v-if="form.usa_fecha_limite" class="q-row q-mar-top-sm">
            <div class="q-col-7">
              <label class="label-q">Fecha (Europe/Madrid)</label>
              <input type="date" class="input-q" v-model="form.fecha_limite">
            </div>
            <div class="q-col-5">
              <label class="label-q">Hora</label>
              <input
                :type="usarPickerNativo ? 'time' : 'text'"
                class="input-q"
                v-model="form.hora_limite"
                :placeholder="usarPickerNativo ? '' : 'HH:MM'"
                :inputmode="usarPickerNativo ? undefined : 'numeric'"
                autocomplete="off"
              />
              <p class="help-q">
                Zona horaria usada: <b>{{ tzLocal }}</b> (recomendado: Europe/Madrid).
              </p>
            </div>
          </div>
        </div>

        <!-- DESCUENTOS – ALTA -->
        <div v-if="esAlta" class="descuento-box q-pad q-rounded q-mar-bottom">
          <div class="descuento-header">
            <h6 class="label-q-bold mb-1">Descuentos</h6>
            <p class="descuento-help">
              Opcional: añade uno o varios descuentos para este servicio.
            </p>
          </div>
          <div
            v-for="(d, index) in form.descuentos"
            :key="d.id || 'nuevo-' + index"
            class="descuento-item"
          >
            <!-- Código -->
            <div class="descuento-row descuento-row-codigo">
              <div class="descuento-campo">
                <label class="label-q">Código</label>
                <input type="text" class="input-q input-descuento" v-model="d.codigo">
              </div>
            </div>
            <!-- % + usos + acciones -->
            <div class="descuento-row descuento-row-secundaria">
              <div class="descuento-campo descuento-mini">
                <label class="label-q">%</label>
                <input type="number" class="input-q input-descuento input-descuento-mini" v-model="d.porcentaje">
              </div>
              <div class="descuento-campo descuento-mini">
                <label class="label-q">Usos</label>
                <input type="number" class="input-q input-descuento input-descuento-mini" v-model="d.maximos">
              </div>
              <div class="descuento-acciones-inline">
                <label class="label-q label-oculta">Acciones</label>
                <button
                  v-if="index === form.descuentos.length - 1"
                  type="button"
                  class="btn-inline-accion btn-inline-add"
                  @click="agregarDescuento"
                  title="Añadir descuento"
                >
                  +
                </button>
                <button
                  type="button"
                  class="btn-inline-accion btn-inline-remove"
                  @click="form.descuentos.splice(index, 1)"
                  :disabled="form.descuentos.length === 1"
                  title="Quitar descuento"
                >
                  -
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- DESCUENTOS – EDITA -->
        <div v-if="esEdita" class="descuento-box q-pad q-rounded q-mar-bottom">
          <label class="label-q-bold">Descuentos existentes:</label>
          <div v-if="form.descuentos.length > 0">
            <div v-for="d in form.descuentos" :key="d.id" class="mb-2">
              <!-- Modo lectura -->
              <div v-if="descuentoEnEdicion !== d.id">
                <strong>
                  {{ d.codigo }}
                  <span v-if="d.activo === 0" class="text-muted">(desactivado)</span>
                </strong>
                — {{ d.porcentaje }}%
                <br>
                Usados: {{ d.usados }} / {{ d.maximos }}
                <div class="acciones-descuento">
                  <a href="#" @click.prevent="descuentoEnEdicion = d.id">Editar descuento</a>
                  ·
                  <a href="#"
                    @click.prevent="toggleDescuento(d)"
                    :class="d.activo ? 'text-danger' : 'text-success'">
                    {{ d.activo ? 'Desactivar' : 'Activar' }}
                  </a>
                </div>
                <hr>
              </div>
              <!-- Modo edición inline -->
              <div v-else class="inline-editor">
                <label class="label-q mb-1">Nombre del descuento</label>
                <soft-field name="codigo" v-model="d.codigo" largo="50" class="mb-3" />
                <label class="label-q mb-1">Porcentaje (%)</label>
                <soft-field name="porcentaje" type="number" v-model="d.porcentaje" class="mb-3" />
                <label class="label-q mb-1">Máximos usos</label>
                <soft-field name="maximos" type="number" v-model="d.maximos" class="mb-3" />
                <QBtn variant="tipster" label="Guardar" class="mt-2" @click="guardarEdicionInline(d)" />
                <QBtn variant="neutro" label="Cancelar" class="mt-2 ms-2" @click="descuentoEnEdicion = null" />
                <hr>
              </div>
            </div>
          </div>
          <p v-else>No hay descuentos registrados.</p>
        </div>

        <!-- ACTIVO -->
        <div class="q-mar-top">
          <div class="switch-row-q">
            <button
              type="button"
              role="switch"
              :aria-checked="form.activo"
              class="q-toggle"
              :class="{ 'q-toggle--on': form.activo }"
              @click="form.activo = !form.activo"
            >
              <span class="q-toggle-knob"></span>
            </button>
            <span class="switch-label-q" :class="form.activo ? 'text-activo' : 'text-inactivo'">
              {{ form.activo ? '🟢 Servicio activo' : '🔴 Servicio inactivo' }}
            </span>
          </div>
        </div>

        <!-- PASARELAS DE PAGO -->
        <div class="q-mar-top pasarelas-section">
          <label class="label-q mb-2">Pasarelas de pago</label>
          <div v-if="loadingPasarelas" class="pasarelas-loading">
            <span class="spinner-border spinner-border-sm"></span>
            <span class="ms-2 text-muted text-sm">Cargando pasarelas…</span>
          </div>
          <div v-else-if="miRol == 1 && !form.tipsterid" class="pasarelas-empty">
            Selecciona un tipster para ver sus pasarelas.
          </div>
          <div v-else-if="!pasarelasDisponibles.length" class="pasarelas-empty">
            Este tipster no tiene pasarelas creadas.
          </div>
          <div v-else class="pasarelas-grid">
            <label
              v-for="p in pasarelasDisponibles"
              :key="p.id"
              class="pasarela-check"
              :class="{ 'pasarela-check--selected': pasarelasSeleccionadas.includes(p.id) }"
            >
              <input
                type="checkbox"
                :value="p.id"
                :checked="pasarelasSeleccionadas.includes(p.id)"
                @change="togglePasarela(p.id)"
              />
              <span class="pasarela-nombre">{{ p.nombre }}</span>
              <span class="pasarela-estado" :class="`estado-${p.estado}`">{{ p.estado }}</span>
            </label>
          </div>
        </div>

        <!-- BOTONES -->
        <div class="q-flex-between q-mar-top q-actions">
          <button
            type="button"
            class="btn-q-secondary"
            @click="$emit('cerrar-modal')"
          >
            Volver
          </button>
          <button
            type="submit"
            class="btn-q-primary"
            :disabled="loading || (esAlta && !formValido)"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <span v-else>{{ esAlta ? 'Guardar servicio' : 'Confirmar' }}</span>
          </button>
        </div>

      </Form>

      <!-- MODAL PRECIO DINÁMICO (compartido) -->
      <ModalPrecioDinamico
        :visible="modalPrecioDinamicoVisible"
        :precio-base="form.precio"
        v-model="form.precio_dinamico"
        @cerrar="modalPrecioDinamicoVisible = false"
      />

      <!-- MODAL INSTRUCCIONES BOT (solo alta) -->
      <ModalInstruccionesBot
        v-if="esAlta"
        :visible="mostrarModalInstrucciones"
        :enlace="form.enlace"
        :codigo-init="codigoInit"
        :bot-name="botName"
        @cerrar="mostrarModalInstrucciones = false"
        @reintentar="reintentarVerificacion"
      />

    </div>
  </div>
</template>

<script>
import ModalInstruccionesBot from "@/components/ModalInstruccionesBot.vue";
import ModalPrecioDinamico from "@/components/ModalPrecioDinamico.vue";
import SoftField from "@/components/SoftField.vue";
import SoftSelect from "@/components/SoftSelect.vue";
import showSwal from "/src/mixins/showSwal.js";
import { Form } from "vee-validate";
import * as yup from "yup";
import { listarPasarelasDelTipster, syncPasarelasProducto } from "@/services/pasarelas.service.js";

export default {
  name: "ProductoForm",

  components: {
    SoftField,
    SoftSelect,
    Form,
    ModalInstruccionesBot,
    ModalPrecioDinamico,
  },

  props: {
    modo: { type: String, required: true }, // 'alta' | 'edita'
    botName: { type: String, default: "" }, // solo alta
    // edita:
    productoId: Number,
    productoNombre: String,
    productoEnlace: String,
    productoPrecio: String,
    productoActivo: Boolean,
    productoTipsterId: String,
    productoDescripcion: String,
    productoTipoVenta: String,
    productoPublicoObjetivo: String,
    productoUsaFecha: Boolean,
    productoFechaLimite: String,
    productoHoraLimite: String,
    productoDescuentos: Array,
    productoCanalUuid: String,
    productoTieneSuscriptores: { type: Boolean, default: false },
    productoDiasGracia: { type: Number, default: 0 },
    productoMoneda: { type: String, default: 'EUR' },
  },

  emits: ["cerrar-modal"],

  data() {
    const isAlta = this.modo === "alta";

    const schemaAlta = yup.object().shape({
      nombre: yup
        .string()
        .required("El nombre es necesario!")
        .max(80, "El tamaño máximo es de 80 caracteres"),
      enlace: yup
        .string()
        .required("El enlace es necesario!")
        .url("Debe indicar un enlace válido"),
      precio: yup
        .number()
        .typeError("El precio debe ser un número válido")
        .required("El precio es necesario!")
        .min(0, "El precio no puede ser negativo")
        .test("is-decimal", "El precio debe tener como máximo 2 decimales", (value) => {
          if (value == null) return true;
          return Number(value.toFixed(2)) === value;
        }),
    });

    const schemaEdita = yup.object().shape({
      nombre: yup.string().required().max(50),
      enlace: yup.string().required().url(),
      precio: yup.number().required().positive(),
    });

    return {
      loading: false,
      schema: isAlta ? schemaAlta : schemaEdita,
      tipsters: [],
      modalPrecioDinamicoVisible: false,

      // Alta-only
      formValido: false,
      canalVerificado: false,
      botEnCanal: false,
      estadoVerificacionEnlace: "idle", // idle | checking | ok | error
      mensajeVerificacionEnlace: "",
      mostrarModalInstrucciones: false,
      verificarCanalTimeout: null,
      codigoInit: "",

      // Pasarelas
      pasarelasDisponibles: [],
      pasarelasSeleccionadas: [],
      loadingPasarelas: false,

      // Edita-only
      descuentoEnEdicion: null,
      productoEditRebajaUsados: 0,
      canales: {},

      form: {
        nombre: isAlta ? "" : (this.productoNombre || ""),
        enlace: isAlta ? "" : (this.productoEnlace || ""),
        precio: isAlta ? "0" : (this.productoPrecio || "0"),
        tipsterid: isAlta
          ? (this.$store.getters["auth/rolEfectivo"] == 2 ? localStorage.getItem("usuarioTipsterId") : null)
          : (this.productoTipsterId || null),
        activo: isAlta ? false : (this.productoActivo || false),
        descripcion: isAlta ? "" : (this.productoDescripcion || ""),
        tipo_venta: isAlta ? "venta_unica" : (this.productoTipoVenta || "venta_unica"),
        moneda: isAlta ? "EUR" : (this.productoMoneda || "EUR"),
        dias_gracia: isAlta ? 0 : (Number(this.productoDiasGracia) || 0),
        publico_objetivo: isAlta ? "" : (this.productoPublicoObjetivo || ""),
        usa_fecha_limite: isAlta ? false : Boolean(Number(this.productoUsaFecha)),
        fecha_limite: isAlta ? "" : (this.productoFechaLimite || ""),
        hora_limite: isAlta ? "" : (this.productoHoraLimite || ""),
        canal_uuid: isAlta ? "" : (this.productoCanalUuid || ""),
        descuentos: isAlta
          ? [{ codigo: "", porcentaje: "", maximos: "" }]
          : (this.productoDescuentos || []),
        usar_precio_dinamico: false,
        precio_dinamico: {
          precio_normal: "",
          descuento_predefinido: "",
          descuento_manual: "",
          precio_rebajado: "",
          limite_usos: "",
          activo: false,
        },
      },
    };
  },

  computed: {
    esAlta() { return this.modo === "alta"; },
    esEdita() { return this.modo === "edita"; },
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
    monedasDisponibles() {
      return [
        { code: 'EUR', nombre: 'Euro' },
        { code: 'USD', nombre: 'Dólar estadounidense' },
        { code: 'GBP', nombre: 'Libra esterlina' },
        { code: 'BRL', nombre: 'Real brasileño' },
        { code: 'MXN', nombre: 'Peso mexicano' },
        { code: 'ARS', nombre: 'Peso argentino' },
        { code: 'CLP', nombre: 'Peso chileno' },
        { code: 'COP', nombre: 'Peso colombiano' },
      ];
    },
    simboloMoneda() {
      const map = { EUR: '€', USD: '$', GBP: '£', BRL: 'R$', MXN: '$MX', ARS: '$AR', CLP: '$CL', COP: '$CO' };
      return map[this.form.moneda] || this.form.moneda;
    },
    esSuscripcion() {
      return this.form.tipo_venta !== 'venta_unica';
    },
    intervalosRecurrentes() {
      return [
        { value: 'diario',     label: 'Diario' },
        { value: 'semanal',    label: 'Semanal' },
        { value: 'quincenal',  label: 'Quincenal' },
        { value: 'mensual',    label: 'Mensual' },
        { value: 'trimestral', label: 'Trimestral' },
        { value: 'semestral',  label: 'Semestral' },
        { value: 'anual',      label: 'Anual' },
      ];
    },
    labelIntervalo() {
      const map = {
        diario: 'cada día', semanal: 'cada semana', quincenal: 'cada dos semanas',
        mensual: 'cada mes', trimestral: 'cada 3 meses',
        semestral: 'cada 6 meses', anual: 'cada año',
      };
      return map[this.form.tipo_venta] || 'de forma recurrente';
    },
    usarPickerNativo() {
      return typeof navigator !== "undefined" && /iPhone|iPad|Android/i.test(navigator.userAgent);
    },
    tzLocal() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Madrid";
    },
    precioValido() {
      const p = Number(String(this.form.precio ?? "").replace(",", "."));
      return Number.isFinite(p) && p > 0;
    },
    tienePrecioDinamicoConfig() {
      const pd = this.form.precio_dinamico || {};
      const n = (v) => Number(String(v ?? "").replace(",", "."));
      return (
        (Number.isFinite(n(pd.precio_rebajado)) && n(pd.precio_rebajado) > 0) ||
        (Number.isFinite(n(pd.descuento_manual)) && n(pd.descuento_manual) > 0) ||
        (Number.isFinite(n(pd.descuento_predefinido)) && n(pd.descuento_predefinido) > 0)
      );
    },
    precioFinalPreview() {
      const normal = Number(String(this.form.precio ?? "").replace(",", "."));
      if (!Number.isFinite(normal) || normal <= 0) return this.esEdita ? "0.00" : 0;

      const pd = this.form.precio_dinamico || {};
      const activo = this.esAlta ? this.form.usar_precio_dinamico : pd.activo;
      if (!activo) return this.esEdita ? normal.toFixed(2) : normal;

      const pr = Number(String(pd.precio_rebajado ?? "").replace(",", "."));
      if (Number.isFinite(pr) && pr > 0) return this.esEdita ? pr.toFixed(2) : pr;

      const dm = Number(String(pd.descuento_manual ?? "").replace(",", "."));
      if (Number.isFinite(dm) && dm > 0) {
        const r = Number((normal * (1 - dm / 100)).toFixed(2));
        return this.esEdita ? r.toFixed(2) : r;
      }

      const dp = Number(String(pd.descuento_predefinido ?? "").replace(",", "."));
      if (Number.isFinite(dp) && dp > 0) {
        const r = Number((normal * (1 - dp / 100)).toFixed(2));
        return this.esEdita ? r.toFixed(2) : r;
      }

      return this.esEdita ? normal.toFixed(2) : normal;
    },
  },

  watch: {
    // Alta: recalcula formValido al cambiar form
    form: {
      deep: true,
      handler() {
        if (!this.esAlta) return;
        this.formValido =
          this.form.nombre.trim() !== "" &&
          this.form.enlace.trim() !== "" &&
          this.form.precio !== "" &&
          this.canalVerificado &&
          this.botEnCanal;
      },
    },

    // Alta: auto-verificar canal al cambiar enlace
    "form.enlace": {
      immediate: false,
      handler(nuevo) {
        if (!this.esAlta) return;
        this.resetVerificacionCanal();
        const enlace = (nuevo || "").trim();
        if (!enlace) return;
        if (this.miRol == 1 && !this.form.tipsterid) return;
        if (this.verificarCanalTimeout) clearTimeout(this.verificarCanalTimeout);
        this.verificarCanalTimeout = setTimeout(() => this.verificarCanal(), 700);
      },
    },

    // Alta: formatear hora manualmente (cuando no hay picker nativo)
    "form.hora_limite": {
      handler(nuevo) {
        if (this.usarPickerNativo) return;
        const raw = String(nuevo || "");
        const digits = raw.replace(/\D/g, "").slice(0, 4);
        if (!digits) {
          if (raw !== "") this.form.hora_limite = "";
          return;
        }
        let out = digits;
        if (digits.length >= 3) out = digits.slice(0, 2) + ":" + digits.slice(2);
        if (out !== raw) this.form.hora_limite = out;
      },
    },

    // Alta: re-verificar canal al cambiar tipster (admin)
    "form.tipsterid": {
      handler(nuevo) {
        if (!this.esAlta) return;
        if (this.miRol == 1 && nuevo && (this.form.enlace || "").trim()) {
          this.resetVerificacionCanal();
          this.verificarCanal();
        }
        // Solo para admin: carga pasarelas al seleccionar tipster
        // Para tipster (rol 2/4) se carga en mounted()
        if (this.miRol == 1) {
          this.cargarPasarelas(nuevo, null);
        }
      },
    },

    // Edita: recargar formulario cuando cambia el productoId
    productoId: {
      immediate: true,
      handler() {
        if (!this.esEdita) return;
        this.form.nombre = this.productoNombre || "";
        this.form.enlace = this.productoEnlace || "";
        this.form.precio = this.productoPrecio || "0";
        this.form.tipsterid = this.productoTipsterId || null;
        this.form.activo = this.productoActivo || false;
        this.form.descripcion = this.productoDescripcion || "";
        this.form.tipo_venta = this.productoTipoVenta || "venta_unica";
        this.form.moneda = this.productoMoneda || "EUR";
        this.form.dias_gracia = Number(this.productoDiasGracia) || 0;
        this.form.publico_objetivo = this.productoPublicoObjetivo || "";
        this.form.usa_fecha_limite = Boolean(Number(this.productoUsaFecha));
        this.form.fecha_limite = this.productoFechaLimite || "";
        this.form.hora_limite = this.productoHoraLimite || "";
        this.form.descuentos = this.productoDescuentos || [];
        this.form.canal_uuid = this.productoCanalUuid || "";
        this.$nextTick(() => {
          const editor = document.querySelector("trix-editor[input='descripcion']");
          if (editor) editor.editor.loadHTML(this.form.descripcion);
        });
        this.cargarCanales();
        this.cargarRebaja();
        this.cargarPasarelas(this.productoTipsterId || 0, this.productoId);
      },
    },
  },

  methods: {
    // ──────────────────────────────── ALTA ────────────────────────────────

    resetFormulario() {
      this.resetVerificacionCanal();

      setTimeout(() => {
        const editor = document.querySelector("trix-editor[input='descripcion']");
        if (editor) editor.editor.loadHTML("");
      }, 50);

      this.form = {
        nombre: "",
        enlace: "",
        precio: "0",
        tipsterid: this.miRol == 2 ? localStorage.getItem("usuarioTipsterId") : null,
        activo: false,
        descripcion: "",
        tipo_venta: "venta_unica",
        dias_gracia: 0,
        publico_objetivo: "",
        usa_fecha_limite: false,
        fecha_limite: "",
        hora_limite: "",
        canal_uuid: "",
        descuentos: [{ codigo: "", porcentaje: "", maximos: "" }],
        usar_precio_dinamico: false,
        precio_dinamico: {
          precio_normal: "",
          descuento_predefinido: "",
          descuento_manual: "",
          precio_rebajado: "",
          limite_usos: "",
          activo: false,
        },
      };
      this.modalPrecioDinamicoVisible = false;
    },

    togglePrecioDinamico() {
      if (!this.form.precio_dinamico) {
        this.form.precio_dinamico = {
          precio_normal: "",
          descuento_predefinido: "",
          descuento_manual: "",
          precio_rebajado: "",
          limite_usos: "",
          activo: false,
        };
      }

      if (this.form.usar_precio_dinamico) {
        this.form.precio_dinamico.precio_normal = String(this.form.precio || "0");
        this.form.precio_dinamico.activo = true;
        this.modalPrecioDinamicoVisible = true;
      } else {
        this.form.precio_dinamico = {
          precio_normal: "",
          descuento_predefinido: "",
          descuento_manual: "",
          precio_rebajado: "",
          limite_usos: "",
          activo: false,
        };
        this.modalPrecioDinamicoVisible = false;
      }
    },

    async verificarCanal() {
      if (this.miRol == 1 && !this.form.tipsterid) {
        this.estadoVerificacionEnlace = "error";
        this.mensajeVerificacionEnlace =
          "Primero debes seleccionar el tipster antes de verificar el canal.";
        return;
      }
      this.canalVerificado = false;
      this.botEnCanal = false;
      this.mensajeVerificacionEnlace = "";
      this.estadoVerificacionEnlace = "checking";
      this.codigoInit = "";

      const enlace = (this.form.enlace || "").trim();
      if (!enlace) {
        this.estadoVerificacionEnlace = "idle";
        return;
      }

      const patronTelegram = /(https?:\/\/t\.me\/|^t\.me\/|^@)/i;
      if (!patronTelegram.test(enlace)) {
        this.estadoVerificacionEnlace = "error";
        this.mensajeVerificacionEnlace =
          "Debe indicar un enlace o nombre de canal de Telegram (https://t.me/..., t.me/..., @canal).";
        return;
      }

      try {
        const resp = await this.$store.dispatch("auth/verificarCanal", {
          enlace: enlace,
          nombre_servicio: this.form.nombre || "",
          tipsterid: this.form.tipsterid || null,
          codigo_init: this.form.canal_uuid || "",
        });

        if (resp.res === "OK") {
          this.canalVerificado = true;
          this.botEnCanal = !!resp.bot_en_canal;
          this.estadoVerificacionEnlace = "ok";
          this.codigoInit = resp.codigo_init || "";
          this.form.canal_uuid = resp.codigo_init || "";
          this.mensajeVerificacionEnlace = resp.mensaje || "Verificación realizada correctamente.";

          if (!resp.canal_inicializado) {
            this.mostrarModalInstrucciones = true;
          } else {
            this.mostrarModalInstrucciones = false;
          }
        } else {
          this.estadoVerificacionEnlace = "error";
          this.mensajeVerificacionEnlace = resp.mensaje || "No se ha podido verificar el canal.";
          this.mostrarModalInstrucciones = false;
        }
      } catch (e) {
        console.error(e);
        this.estadoVerificacionEnlace = "error";
        this.mensajeVerificacionEnlace = "Error al verificar el canal. Inténtalo de nuevo.";
        this.mostrarModalInstrucciones = false;
      }
    },

    reintentarVerificacion() {
      this.mostrarModalInstrucciones = false;
      this.verificarCanal();
    },

    resetVerificacionCanal() {
      this.canalVerificado = false;
      this.botEnCanal = false;
      this.estadoVerificacionEnlace = "idle";
      this.mensajeVerificacionEnlace = "";
      this.codigoInit = "";
      this.form.canal_uuid = "";
    },

    async handleAlta() {
      if (!this.canalVerificado || !this.botEnCanal) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Antes de dar de alta el servicio debes conectar el bot al canal y verificarlo.",
          width: 520,
        });
        return;
      }
      if (this.form.usa_fecha_limite && !this.usarPickerNativo) {
        const h = String(this.form.hora_limite || "").trim();
        const ok = /^([01]\d|2[0-3]):[0-5]\d$/.test(h);
        if (!ok) {
          showSwal.methods.showSwal({
            type: "warning",
            message: "La hora debe tener formato HH:MM (ej: 09:30).",
            width: 520,
          });
          return;
        }
      }

      this.loading = true;
      try {
        const altaPayload = {
          ...this.form,
          dias_gracia: this.form.tipo_venta === 'venta_unica' ? 0 : (Number(this.form.dias_gracia) || 0),
        };
        const resp = await this.$store.dispatch("auth/guardaProducto", altaPayload);
        this.loading = false;
        if (resp.res == "OK") {
          await this.doSyncPasarelas(resp.id);
          showSwal.methods.showSwal({
            type: "success",
            message: "Se ha registrado el nuevo producto",
            width: 600,
          });
          this.$emit("cerrar-modal");
        } else {
          showSwal.methods.showSwal({
            type: "error",
            message: resp.mensaje,
            width: 500,
          });
        }
      } catch (error) {
        this.loading = false;
        showSwal.methods.showSwal({
          type: "error",
          message: error.response?.data?.mensaje || "Se ha producido un error",
          width: 500,
        });
      }
    },

    // ──────────────────────────────── EDITA ────────────────────────────────

    togglePrecioDinamicoEdita() {
      if (this.form.precio_dinamico.activo) {
        this.modalPrecioDinamicoVisible = true;
      }
    },

    async cargarRebaja() {
      try {
        const resp = await this.$store.dispatch("auth/obtenerRebajaProducto", {
          producto_id: this.productoId,
        });

        if (resp?.res === "OK" && resp.rebaja) {
          const r = resp.rebaja;
          this.productoEditRebajaUsados = Number(r.usados ?? 0);
          this.form.precio_dinamico.activo = Number(r.activo) === 1;
          this.form.precio_dinamico.descuento_predefinido = "";
          this.form.precio_dinamico.descuento_manual = "";
          this.form.precio_dinamico.precio_rebajado = "";

          if (r.tipo === "precio_fijo") {
            this.form.precio_dinamico.precio_rebajado = r.precio_fijo ?? "";
          } else {
            this.form.precio_dinamico.descuento_manual = r.porcentaje ?? "";
          }

          this.form.precio_dinamico.limite_usos =
            r.limite_usos === null || r.limite_usos === undefined
              ? ""
              : String(r.limite_usos);
        } else {
          this.productoEditRebajaUsados = 0;
          this.form.precio_dinamico = {
            precio_normal: "",
            descuento_predefinido: "",
            descuento_manual: "",
            precio_rebajado: "",
            limite_usos: "",
            activo: false,
          };
        }
      } catch (e) {
        console.error("Error cargando rebaja:", e);
      }
    },

    async cargarPasarelas(tipsterId, productoId) {
      const esAdmin = this.miRol == 1;
      // Admin sin tipster seleccionado: nada que mostrar
      if (esAdmin && !tipsterId) {
        this.pasarelasDisponibles = [];
        this.pasarelasSeleccionadas = [];
        return;
      }
      this.loadingPasarelas = true;
      try {
        // Para no-admins el backend usa el tipster_id del token; mandamos 0
        const res = await listarPasarelasDelTipster(tipsterId || 0, productoId || 0);
        this.pasarelasDisponibles = res.data?.pasarelas || [];
        this.pasarelasSeleccionadas = this.pasarelasDisponibles
          .filter(p => p.tiene_producto)
          .map(p => p.id);
      } catch {
        this.pasarelasDisponibles = [];
        this.pasarelasSeleccionadas = [];
      } finally {
        this.loadingPasarelas = false;
      }
    },

    togglePasarela(id) {
      const idx = this.pasarelasSeleccionadas.indexOf(id);
      if (idx === -1) this.pasarelasSeleccionadas.push(id);
      else this.pasarelasSeleccionadas.splice(idx, 1);
    },

    async doSyncPasarelas(productoId) {
      if (!productoId || !this.pasarelasDisponibles.length) return;
      try {
        await syncPasarelasProducto(productoId, this.pasarelasSeleccionadas);
      } catch {
        showSwal.methods.showSwal({
          type: "warning",
          message: "El servicio se guardó pero no se pudieron asignar las pasarelas. Edítalo para intentarlo de nuevo.",
          width: 540,
        });
      }
    },

    async cargarCanales() {
      try {
        const tipsterId = this.form.tipsterid || this.productoTipsterId || null;
        if (!tipsterId) {
          this.canales = {};
          return;
        }
        const resp = await this.$store.dispatch("auth/listaCanales", { tipsterid: tipsterId });
        const lista = resp?.data ?? resp ?? [];
        const opciones = {};
        for (const c of lista) {
          if (c?.uuid) opciones[c.uuid] = c.nombre ? `${c.nombre} (${c.uuid})` : c.uuid;
        }
        this.canales = opciones;
        if (this.form.canal_uuid && !this.canales[this.form.canal_uuid]) {
          this.form.canal_uuid = "";
        }
      } catch (e) {
        console.error("Error cargando canales:", e);
        this.canales = {};
      }
    },

    toggleDescuento(d) {
      d.activo = d.activo ? 0 : 1;
    },

    guardarEdicionInline(desc) {
      this.form.descuentos = this.form.descuentos.map((d) =>
        d.id === desc.id ? { ...desc } : d
      );
      this.descuentoEnEdicion = null;
      showSwal.methods.showSwal({
        type: "success",
        message: "Cambios aplicados (pendientes de guardar)",
      });
    },

    async handleEdita() {
      this.loading = true;

      if (this.form.precio_dinamico.activo) {
        const tieneAlgo =
          (this.form.precio_dinamico.precio_rebajado !== "" && this.form.precio_dinamico.precio_rebajado !== null) ||
          (this.form.precio_dinamico.descuento_manual !== "" && this.form.precio_dinamico.descuento_manual !== null) ||
          (this.form.precio_dinamico.descuento_predefinido !== "" && this.form.precio_dinamico.descuento_predefinido !== null);

        if (!tieneAlgo) {
          showSwal.methods.showSwal({
            type: "error",
            message: "Activa el precio dinámico, pero configúralo en el modal (predefinido, manual o precio fijo).",
          });
          this.loading = false;
          return;
        }
      }

      const pd = this.form.precio_dinamico;
      const payload = {
        id: this.productoId,
        nombre: this.form.nombre,
        enlace: this.form.enlace,
        precio: this.form.precio,
        activo: this.form.activo,
        tipsterid: this.form.tipsterid,
        descripcion: this.form.descripcion,
        tipo_venta: this.form.tipo_venta || "venta_unica",
        moneda: this.form.moneda || "EUR",
        dias_gracia: this.form.tipo_venta === 'venta_unica' ? 0 : (Number(this.form.dias_gracia) || 0),
        publico_objetivo: this.form.publico_objetivo || null,
        usa_fecha_limite: this.form.usa_fecha_limite ? 1 : 0,
        fecha_limite: this.form.fecha_limite,
        hora_limite: this.form.hora_limite,
        canal_uuid: this.form.canal_uuid || null,
        usar_precio_dinamico: pd.activo ? 1 : 0,
        precio_dinamico: {
          precio_normal: (this.form.precio === "" || this.form.precio === null)
            ? null
            : Number(this.form.precio),
          descuento_predefinido: pd.descuento_predefinido === "" ? null : Number(pd.descuento_predefinido),
          descuento_manual: pd.descuento_manual === "" ? null : Number(pd.descuento_manual),
          precio_rebajado: pd.precio_rebajado === "" ? null : Number(pd.precio_rebajado),
          limite_usos: (pd.limite_usos === "" || pd.limite_usos === null)
            ? null
            : Number(pd.limite_usos),
          activo: pd.activo ? 1 : 0,
        },
        descuentos: this.form.descuentos.map((d) => ({
          id: d.id,
          codigo: d.codigo,
          porcentaje: d.porcentaje,
          maximos: d.maximos,
          activo: d.activo ?? 1,
        })),
      };

      try {
        const resp = await this.$store.dispatch("auth/guardaProducto", payload);
        if (resp.res == "OK") {
          await this.doSyncPasarelas(resp.id || this.productoId);
          showSwal.methods.showSwal({
            type: "success",
            message: "Producto actualizado",
          });
          this.$emit("cerrar-modal");
        } else {
          showSwal.methods.showSwal({
            type: "error",
            message: resp.mensaje,
          });
        }
      } catch (e) {
        showSwal.methods.showSwal({
          type: "error",
          message: e.response?.data?.mensaje || "Se ha producido un error",
        });
      }

      this.loading = false;
    },

    // ──────────────────────────────── COMPARTIDOS ────────────────────────────────

    agregarDescuento() {
      this.form.descuentos.push({ codigo: "", porcentaje: "", maximos: "" });
    },

    handleSubmit() {
      if (this.esAlta) {
        this.handleAlta();
      } else {
        this.handleEdita();
      }
    },
  },

  beforeUnmount() {
    if (this.verificarCanalTimeout) {
      clearTimeout(this.verificarCanalTimeout);
    }
  },

  async mounted() {
    setTimeout(() => {
      const input = document.querySelector("#nombre input, #nombre");
      if (input) input.focus();
    }, 150);

    if (this.miRol === 1) {
      this.tipsters = await this.$store.dispatch("auth/listaTipsters");
    }

    if (this.esAlta) {
      this.resetFormulario();
      // No-admin: tipsterid viene del token, watcher no dispara, cargamos aquí
      if (this.miRol != 1) {
        this.cargarPasarelas(0, null);
      }
    } else {
      // El watcher productoId (immediate:true) ya llama cargarCanales, cargarRebaja y cargarPasarelas
    }

    this.$nextTick(() => window.dispatchEvent(new Event("resize")));
  },
};
</script>

<style scoped>

/* =========================================
   TÍTULOS
========================================= */
.titulo-empirulado {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--q-text);
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

/* =========================================
   CONTENEDORES
========================================= */
.q-pad { padding: 1.5rem; }
.q-mar-top { margin-top: 1rem; }
.q-mar-top-sm { margin-top: 0.5rem; }
.q-mar-bottom { margin-bottom: 1rem; }
.q-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* =========================================
   TARJETA PRINCIPAL
========================================= */
.card-empirulada {
  background: var(--q-card);
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--q-border);
  padding: 1.5rem;
}

/* =========================================
   INPUTS
========================================= */
.input-q,
.card-empirulada input,
.card-empirulada select {
  width: 100%;
  height: 44px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.95rem;
}

.input-q:focus {
  outline: none;
  border-color: var(--q-gold);
  box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.2);
}

/* =========================================
   BOTONES
========================================= */
.btn-q-primary,
.btn-q-secondary {
  min-width: 180px;
  height: 48px;
  border-radius: 10px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.btn-q-primary { background: var(--q-gold); color: var(--q-gold-on); }
.btn-q-secondary { background: var(--q-hover); color: var(--q-muted); }

/* =========================================
   LABELS
========================================= */
.label-q {
  font-size: 0.85rem;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
  color: var(--q-text);
}

.label-q-bold {
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
}

/* =========================================
   MENSAJES
========================================= */
.help-q { font-size: 0.8rem; }
.help-ok { color: var(--q-green); }
.help-warning { color: var(--q-amber); }
.help-error { color: var(--q-red); }
.text-muted { color: var(--q-muted) !important; font-size: 0.8rem; }
.text-success { color: var(--q-green) !important; }
.text-danger { color: var(--q-red) !important; }

/* =========================================
   PREVIEW PRECIO
========================================= */
.precio-preview {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.precio-normal {
  color: var(--q-red);
  text-decoration: line-through;
  font-weight: 700;
}
.precio-final {
  color: var(--q-green);
  font-weight: 900;
}

/* =========================================
   PRECIO DINÁMICO EDITA
========================================= */
.precio-dinamico-edita {
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1rem;
}

/* =========================================
   SWITCHES
========================================= */
.switch-row-q {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.switch-label-q {
  margin: 0;
  line-height: 1.15;
  font-weight: 800;
  color: var(--q-text);
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

@media (max-width: 420px) {
  .switch-row-q { flex-wrap: wrap; }
  .switch-label-q { flex-basis: calc(100% - 60px); }
}

:deep(.q-switch .form-check.form-switch),
:deep(.form-check.form-switch) {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding-left: 0 !important;
}

:deep(.q-switch .form-check.form-switch .form-check-input),
:deep(.form-check.form-switch .form-check-input) {
  margin: 0 !important;
  margin-left: 0 !important;
  flex: 0 0 auto;
}

:deep(.form-check.form-switch .form-check-label) {
  margin: 0;
  line-height: 1.15;
  font-weight: 800;
  color: var(--q-text);
}

.bloque-fecha-limite {
  margin-bottom: 24px;
}

/* =========================================
   TRIX EDITOR
========================================= */
trix-editor.descripcion-trix {
  min-height: 120px;
  background: var(--q-card-alt);
  color: var(--q-text);
  border: 1px solid var(--q-border);
  border-radius: 10px;
  padding: 12px;
}

.trix-wrap {
  position: relative;
  margin-bottom: 22px;
}

:deep(trix-toolbar) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 10px 0 0 0;
  outline: none !important;
}

:deep(trix-toolbar .trix-button-group) {
  border: 1px solid var(--q-border) !important;
  border-radius: 12px !important;
  overflow: hidden;
  background: var(--q-card);
}

:deep(trix-toolbar .trix-button),
:deep(trix-toolbar .trix-button:focus),
:deep(trix-toolbar .trix-button:active),
:deep(trix-toolbar .trix-button:focus-visible) {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
  -webkit-tap-highlight-color: transparent;
  color: var(--q-text-muted, #9aa) !important;
  background: transparent !important;
}
:deep(trix-toolbar .trix-button:hover) {
  color: var(--q-text) !important;
  background: var(--q-hover) !important;
}
:deep(trix-toolbar .trix-button.trix-active) {
  color: var(--q-gold, #f5a623) !important;
  background: var(--q-hover) !important;
}
:deep(trix-toolbar .trix-button--icon::before) {
  filter: invert(1) opacity(0.7);
}
:deep(trix-toolbar .trix-button--icon:hover::before),
:deep(trix-toolbar .trix-button--icon.trix-active::before) {
  filter: invert(1) opacity(1);
}

:deep(trix-toolbar .trix-button + .trix-button) {
  border-left: 1px solid var(--q-border) !important;
}

@media (max-width: 768px) {
  .trix-wrap {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    margin-bottom: 26px;
  }

  :deep(trix-toolbar) {
    position: sticky;
    bottom: 0;
    z-index: 5;
    padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;
  }
}

/* =========================================
   DESCUENTOS
========================================= */
.descuento-box {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-left: 4px solid var(--q-gold);
  border-radius: 10px;
  padding: 0.9rem;
  margin-bottom: 1.5rem;
}

.descuento-header {
  margin-bottom: 0.75rem;
}

.descuento-help {
  margin: 0;
  font-size: 0.82rem;
  color: var(--q-muted);
}

.descuento-item {
  background: var(--q-hover);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 0.75rem;
  margin-bottom: 0.7rem;
}

.descuento-row {
  display: flex;
  gap: 10px;
  align-items: end;
}

.descuento-row + .descuento-row {
  margin-top: 0.55rem;
}

.descuento-campo {
  min-width: 0;
}

.descuento-row-codigo .descuento-campo {
  width: 100%;
}

.descuento-row-secundaria .descuento-mini {
  flex: 1 1 0;
  max-width: 110px;
}

.input-descuento {
  height: 38px;
}

.input-descuento-mini {
  text-align: center;
  padding-left: 8px;
  padding-right: 8px;
}

.descuento-acciones-inline {
  display: flex;
  gap: 8px;
  align-items: end;
  flex: 0 0 auto;
}

.btn-inline-accion {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid var(--q-border);
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.btn-inline-add {
  background: var(--q-hover);
  color: var(--q-gold);
}

.btn-inline-remove {
  background: var(--q-red-soft);
  color: var(--q-red);
  border-color: var(--q-border);
}

.btn-inline-remove:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.label-oculta {
  visibility: hidden;
}

/* Descuentos edita */
.acciones-descuento {
  margin-top: 6px;
  font-size: 0.85rem;
}

.acciones-descuento a {
  cursor: pointer;
  color: var(--q-gold);
  text-decoration: underline;
}

.acciones-descuento a.text-danger {
  color: var(--q-red);
}

.inline-editor {
  padding: 0.5rem 0;
}

@media (max-width: 768px) {
  .descuento-row-secundaria {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 10px;
    align-items: end;
  }

  .descuento-row-secundaria .descuento-mini {
    max-width: none;
  }

  .descuento-acciones-inline {
    gap: 6px;
  }
}

@media (max-width: 420px) {
  .descuento-row-secundaria {
    grid-template-columns: 1fr 1fr;
  }

  .descuento-acciones-inline {
    grid-column: 1 / -1;
    justify-content: flex-end;
    margin-top: 2px;
  }

  .label-oculta {
    display: none;
  }
}

/* =========================================
   PÚBLICO OBJETIVO CON BANDERAS
========================================= */
.publico-objetivo-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
  margin-top: 6px;
}

.flag-option {
  height: 58px;
  width: 100%;
  border: 1px solid var(--q-border);
  background: var(--q-card-alt);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.18s ease;
  padding: 0 10px;
}

.flag-option:hover {
  border-color: var(--q-border-md);
  background: var(--q-hover);
  transform: translateY(-1px);
}

.flag-option.active {
  border-color: var(--q-gold);
  background: var(--q-hover);
  box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.15);
}

.flag-option-auto {
  grid-column: 1 / -1;
}

.flag-emoji {
  font-size: 1.15rem;
  line-height: 1;
  flex: 0 0 auto;
}

.flag-icon {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  flex: 0 0 auto;
  display: inline-block;
}

.flag-text {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--q-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =========================================
   RESPONSIVE
========================================= */
@media (max-width: 768px) {
  .q-flex-between {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .btn-q-primary,
  .btn-q-secondary {
    width: 100%;
  }

  .q-actions {
    position: sticky;
    bottom: 0;
    background: var(--q-card);
    padding: 12px 0 calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid var(--q-border);
    z-index: 3;
  }

  .publico-objetivo-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px;
  }

  .flag-option {
    height: 46px;
    border-radius: 10px;
    padding: 0 8px;
    gap: 6px;
  }

  .flag-emoji { font-size: 1rem; }
  .flag-icon { width: 1.2rem; height: 1.2rem; }

  .flag-text {
    font-size: 0.82rem;
  }
}

@media (max-width: 420px) {
  .card-empirulada {
    width: 100%;
    padding: 1rem;
  }

  .publico-objetivo-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px;
  }

  .flag-option {
    height: 44px;
    border-radius: 10px;
    padding: 0 8px;
    justify-content: center;
  }

  .flag-emoji { font-size: 0.95rem; }
  .flag-icon { width: 1.1rem; height: 1.1rem; }

  .flag-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 360px) {
  .card-empirulada {
    width: 100%;
    padding: 1rem;
  }

  .q-flex-between {
    flex-direction: column;
    gap: 1rem;
  }

  .btn-q-primary,
  .btn-q-secondary {
    width: 100%;
  }
}

/* =========================================
   PASARELAS
========================================= */
.pasarelas-section {
  border-top: 1px solid var(--q-border);
  padding-top: 1rem;
}
.pasarelas-loading,
.pasarelas-empty {
  font-size: 0.85rem;
  color: var(--q-muted);
  padding: 0.4rem 0;
}
.pasarelas-grid {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.4rem;
}
.pasarela-check {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--q-border);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  user-select: none;
}
.pasarela-check input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--q-gold);
  flex-shrink: 0;
}
.pasarela-check--selected {
  background: var(--q-hover);
  border-color: var(--q-gold);
}
.pasarela-nombre {
  flex: 1;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--q-text);
}
.pasarela-estado {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 10px;
}
.estado-activa   { background: var(--q-green-soft); color: var(--q-green); }
.estado-borrador { background: var(--q-hover); color: var(--q-muted); }
.estado-pausada  { background: var(--q-amber-soft); color: var(--q-amber); }

/* Tipo de venta */
.tipo-venta-opcion {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 2px solid var(--q-border);
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.15s;
  user-select: none;
}
.tipo-venta-opcion input { display: none; }
.tipo-venta-opcion.active {
  border-color: var(--q-gold);
  background: var(--q-hover);
  color: var(--q-gold);
  font-weight: 600;
}

/* Intervalos de suscripción */
.intervalo-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.btn-intervalo {
  padding: 5px 13px;
  border: 1px solid var(--q-border);
  border-radius: 20px;
  background: var(--q-card-alt);
  color: var(--q-muted);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-intervalo:hover {
  border-color: var(--q-border-md);
  color: var(--q-text);
}
.btn-intervalo.active {
  border-color: var(--q-gold);
  background: var(--q-hover);
  color: var(--q-gold);
}
.btn-intervalo:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Tipo venta bloqueada */
.tipo-venta-bloqueada {
  opacity: 0.5;
  cursor: not-allowed;
}
.aviso-tipo-venta-bloqueado {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  background: rgba(255, 152, 0, 0.08);
  border: 1px solid rgba(255, 152, 0, 0.35);
  border-radius: 8px;
  font-size: 0.85rem;
  color: var(--q-text);
  line-height: 1.4;
}
.aviso-icono { font-size: 1rem; flex-shrink: 0; }
.aviso-texto { color: var(--q-muted); }

/* =========================================
   PRECIO + MONEDA
========================================= */
.precio-moneda-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.precio-col { flex: 1 1 0; min-width: 0; }
.moneda-col { flex: 1 1 0; min-width: 0; }

.select-moneda {
  width: 100%;
  height: 44px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 10px;
  padding: 0 12px;
  font-size: 0.9rem;
  color: var(--q-text);
  cursor: pointer;
  margin-top: 4px;
}
.select-moneda:focus {
  outline: none;
  border-color: var(--q-gold);
  box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.2);
}
.select-moneda:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.aviso-moneda {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  background: rgba(33, 150, 243, 0.08);
  border: 1px solid rgba(33, 150, 243, 0.3);
  border-radius: 8px;
  font-size: 0.83rem;
  color: var(--q-text);
  line-height: 1.5;
  margin-top: 6px;
}
.aviso-moneda-icono { font-size: 1rem; flex-shrink: 0; margin-top: 1px; }
.aviso-moneda-texto { color: var(--q-muted); }

@media (max-width: 480px) {
  .precio-moneda-row { flex-direction: column; }
  .moneda-col { flex: 1 1 100%; }
}

.text-activo  { color: var(--q-green) !important; font-weight: 600; }
.text-inactivo { color: var(--q-red)   !important; font-weight: 600; }
</style>
